import api from './api';

export const addPost = (id, post, config) => {
    let errors = [];
    if (!id) {
        errors.push('id');
    }
    if (!post) {
        errors.push('post');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.post(`/Blog/AddBlog/${id}`, post, config);
    }
}

export const updatePost = (id, post, config) => {
    let errors = [];
    if (!id) {
        errors.push('id');
    }
    if (!post) {
        errors.push('post');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.put(`/Blog/UpdateBlog/${id}`, post, config);
    }
}

export const getPosts = (params, config) => {
    let errors = [];
    if (!params) {
        errors.push('params');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.get(`/Blog/GetBlogs?PageNumber=${params.currentPage}&PageSize=${params.pageSize}`, config);
    }
}

export const getPost = (id, config) => {
    let errors = [];
    if (!id) {
        errors.push('id');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.get(`/Blog/GetBlog/${id}`, config);
    }
}

export const deletePost = (id, config) => {
    let errors = [];
    if (!id) {
        errors.push('id');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.delete(`/Blog/DeleteBlog/${id}`, config);
    }
}